import { LogoHustleUpSmall } from "@images/logoHustleUpSmall"
import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"
import { DefaultTheme } from "styled-components"
import OnboardingBoxStripe from "@images/payment/onboardingBoxStripe.svg"
import { HUButton } from "@modules/ui/components/huButton"
import { SmallArrowIcon } from "@images/svgIcons/arrowIcon"

export const BoxOnboardingStripeFirstPage = (
  theme: DefaultTheme,
  handleButtonNavigation: (onNext: boolean) => void,
  handleButtonTryLiteVersion: () => void,
) => {
  return (
    <div className="relative w-full flex flex-column justify-content-between h-screen">
      {/* HEARDER */}
      <div className="flex align-items-center flex-column w-full mt-5 px-3 text-center">
        <div>
          <LogoHustleUpSmall color={theme.mainWhite} />
        </div>
        <HUText fontStyle="HL" color={theme.mainWhite} className="mt-3 ">
          {word("box.stripe.onboarding.title")}
        </HUText>
        <HUText fontStyle="BL" color={theme.mainWhite} className="mt-1">
          {word("box.stripe.onboarding.screen1.subtitle")}
        </HUText>
      </div>
      {/* CONTENT */}
      <div className="flex sm:flex-row flex-column justify-content-center align-items-center my-4 gap-3">
        {/* ILLUSTRATION FOR SMALL DEVICE  */}
        <div
          className="flex w-full h-10rem align-items-center justify-content-center sm:hidden flex-grow-1 bg-contain bg-no-repeat bg-center"
          style={{ backgroundImage: `url('${OnboardingBoxStripe} ')` }}
        ></div>
        {/* LEFT */}
        <div className="w-11 sm:w-6 md:w-5 lg:w-4 xl:w-3 flex flex-column ">
          <HUText fontStyle="HM" color={theme.mainWhite}>
            {word("box.stripe.onboarding.screen1.content")}
          </HUText>
          <HUButton
            type="Right_Icon"
            size="M"
            colorType="Primary"
            icon={{ icon: () => <SmallArrowIcon color={theme.neutralColor900} width={14} height={14} /> }}
            text={word("box.stripe.onboarding.screen1.button")}
            onClick={() => handleButtonNavigation(false)}
            className="mt-4"
          />
        </div>
        {/* RIGHT */}
        <div
          className="sm:flex h-20rem hidden w-4 xl:w-3 xl:justify-content-center bg-contain bg-no-repeat bg-center"
          style={{ backgroundImage: `url('${OnboardingBoxStripe} ')` }}
        ></div>
      </div>
      {/* LITE VERSION */}
      <div className="w-11 md:w-9 xl:w-7 flex mx-auto sm:flex-row flex-column sm:align-items-center justify-content-center border-round-3xl bg-neutral-800 p-4 mb-8 gap-4 sm:gap-2">
        <HUText fontStyle="BM" color={theme.mainWhite} className="w-full sm:w-8">
          {word("box.stripe.onboarding.screen1.liteVersion.description")}
        </HUText>
        <HUButton
          type="Rounded"
          size="M"
          colorType="Quaternary"
          text={word("box.stripe.onboarding.screen1.liteVersion.button")}
          onClick={() => handleButtonTryLiteVersion()}
          className="h-3rem"
        />
      </div>
    </div>
  )
}
